import network from '@common/network/network';

const DEFAULT_MEMORY_REQUEST_PROMPT = 'What do you remember about this moment?';
let memoryFetchRequestId = 0;

export default {
  createMemoryRequestAction(_, {prompt = DEFAULT_MEMORY_REQUEST_PROMPT, ...params}) {
    return network.memoryRequests.create({...params, prompt});
  },
  fetchMemoryAction(context, {key}) {
    const requestId = ++memoryFetchRequestId;
    context.commit('setMemoryLoadingState', true);
    return network.memoryRequests
      .getPublic({key})
      .then(response => {
        if (requestId === memoryFetchRequestId) {
          context.commit('setMemoryState', response);
        }
        return response;
      })
      .finally(() => {
        if (requestId === memoryFetchRequestId) {
          context.commit('setMemoryLoadingState', false);
        }
      });
  },
  submitMemoryAction(context, {key, text, audio, name}) {
    context.commit('setMemorySubmitLoadingState', true);
    context.commit('setSubmittedMemoryState', null);
    return new Promise((resolve, reject) => {
      network.memoryRequests
        .postPublic({key, text, audio, name})
        .then(response => {
          context.commit('setSubmittedMemoryState', response);
          resolve(response);
        })
        .catch(error => {
          context.commit('setSubmittedMemoryState', null);
          reject(error);
        })
        .finally(() => {
          context.commit('setMemorySubmitLoadingState', false);
        });
    });
  },
};
